import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { quality: () => import('./QualityPage.vue') },
} satisfies FeatureRoutes
